import { render, staticRenderFns } from "./AdminBilling.vue?vue&type=template&id=213ae435"
import script from "./AdminBilling.vue?vue&type=script&lang=js"
export * from "./AdminBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213ae435')) {
      api.createRecord('213ae435', component.options)
    } else {
      api.reload('213ae435', component.options)
    }
    module.hot.accept("./AdminBilling.vue?vue&type=template&id=213ae435", function () {
      api.rerender('213ae435', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminBilling.vue"
export default component.exports